import { Hero } from './components/Hero'
import { RealitySection } from './components/RealitySection'
import { Pillars } from './components/Pillars'
import { WhatsInside } from './components/WhatsInside'
import { BetaStatus } from './components/BetaStatus'
import { Footer } from './components/Footer'

/**
 * Boomshift marketing landing page.
 *
 * Section order (kept intentionally short — one scroll, one story):
 *   1. Hero            — brand, tagline, two CTAs
 *   2. RealitySection  — acknowledge past failures (no shame)
 *   3. Pillars         — three honest things the app does
 *   4. WhatsInside     — concrete, scannable feature list
 *   5. BetaStatus      — honest beta status + closing CTA
 *   6. Footer          — quiet, no fake links
 *
 * If you reorder, keep RealitySection right after Hero so trust is built
 * before any feature/benefit content.
 */
export default function App() {
  return (
    <main className="min-h-screen bg-charcoal-black text-soft-white">
      <Hero />
      <div className="bs-divider" aria-hidden />
      <RealitySection />
      <div className="bs-divider" aria-hidden />
      <Pillars />
      <div className="bs-divider" aria-hidden />
      <WhatsInside />
      <div className="bs-divider" aria-hidden />
      <BetaStatus />
      <Footer />
    </main>
  )
}
